<template>
    <div class="app-container">
      <el-row class="headTop">
        <el-col :span="22">
          类型名：<el-input
            class="w150 mr20"
            placeholder="请输入类型名"
            v-model="params.name"
            clearable>
          </el-input>
          <el-button style="width:100px"   type="primary" icon="el-icon-search"  @click="queryList()">查询</el-button>
        </el-col>
        <el-col :span="2">
          <el-button style="width:100%"   type="success" icon="el-icon-circle-plus-outline" @click="showDialog()">新增</el-button>
        </el-col>
      </el-row>
    <el-dialog :title="addType==1?'增加票类型':'修改票类型'"  :visible.sync="dialogVisible" width="1000px">
        <el-form :model="formparams" :rules="rules" ref="formparams" label-width="120px">
          <el-form-item label="票类型名称" prop="type">
            <el-input class="w220" v-model="formparams.type" placeholder="请输入票类型名称" maxlength="20"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="73vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <!-- <el-table-column width="200px" prop="tid" label="票ID"></el-table-column> -->
        <el-table-column prop="ticketType" label="票类型名称"></el-table-column>
        <!-- <el-table-column label="分店编号">
          <template slot-scope="scope">
            <div> {{scope.row.shopnum|caseType}} </div>
          </template>
          
        </el-table-column> -->
        <el-table-column width="200" label="操作">
          <template slot-scope="scope">
            <el-button style="width:100px"  type="primary" @click="edit(scope.row)">编辑</el-button>
            <!-- <el-button style="width:100px"  type="danger" @click="removeList(scope.row.id)">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pageination">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
let that;
import {getTicketType, updateTicketType,insertTicketType } from "../../api/configApi";
import mainHead from "../../components/mainHead/mainHead";
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      date:[],//开始时间结束时间
      rules:{
        type:[
          { required: true, message: '请输入票类型名称', trigger: 'blur' }
        ],
      },
      timeList:[],
      addType:1,
      formparams:{
        type:''
      },
      formData:{},
      fileList:[],
      //票列表
      tableData:[],
      //票类型
      options:[],
      titleList:[],
      //分店列表
      shopList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      total: 0,
      currentPage: 1,
      params: {
        pageNo: 1,
        pageSize: 20,
        name:null
      }
    }
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  components: {
    mainHead
  },
  beforeCreate(){
    that = this;
  },
  created(){
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    showDialog(){
        this.dialogVisible =true
        this.addType = 1
        this.formparams.type=''
        this.clearForm('formparams')
    },
    queryList(){
      this.params.pageNo = 1;
      this.currentPage = 1
      this.getTableList()
    },
    getTableList(){
      getTicketType(this.params).then((res)=>{
        if(res.msg == "success"){
          this.tableData = res.data.info
          this.total = res.data.total
        }
      })
    },
    //编辑
    edit(row){
      console.log(row)
      this.addType = 2
      this.dialogVisible = true
      this.formparams.type = row.ticketType
      this.formparams.typeId=row.tid
      this.clearForm('formparams')
      // this.formparams.code=row.code
      // this.formparams.shopNum=row.shopnum
      // this.formparams.remark=row.remark
    },
    //添加票
    // insertOnlineTicketInfo
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if (valid) {
          if(this.addType == 1){
            insertTicketType(this.formparams).then((res)=>{
              console.log(res)
              if(res.msg=="success"){
                this.$message({
                  type:'success',
                  message:'添加成功'
                })
              } else{
                this.$message.error(res.data)
              }
              this.dialogVisible = false
              this.getTableList()
            })
          } else {
            updateTicketType(this.formparams).then((res)=>{
              if(res.msg=="success"){
                this.$message({
                  type:'success',
                  message:'修改成功'
                })
              } else{
                this.$message.error(res.data)
              }
              this.dialogVisible = false
              this.getTableList()
            })
          }
          
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      });
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    },
    clearForm(formName) {
      this.$refs[formName].clearValidate();
    },
      //分页
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.params.pageNo = 1;
      this.currentPage = 1;
      this.getTableList()
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getTableList()
    },
  }
};
</script>
<style lang="scss">

</style>


// WEBPACK FOOTER //
// ticketType.vue?df9b10b0